import React from 'react';
import { CircularProgress } from '@mui/material';
import styles from './Loader.module.scss';

export default function Loader() {
  return (
    <CircularProgress className={styles.loader} color={'primary'} size={64} />
  );
}
